import waRequest from './wa-request';

export const baseApi = '/address-alert-notification/v1';

/**
 * Initiate authenticated GET /address-alert-notification/v1/organizations/${organizationId}/configurations
 *
 * @param organizationId
 * @param signal
 * @returns {Promise}
 */
function getConfigurations({pathParams: {organizationId}, signal}) {
  const url = `${baseApi}/organizations/${organizationId}/configurations`;

  return waRequest.requestAuthenticated({url: url, method: 'get', signal});
}

/**
 * Initiate authenticated GET /address-alert-notification/v1/organizations/${organizationId}/configurations/${configurationId}
 *
 * @param organizationId
 * @param configurationId
 * @param signal
 * @returns {Promise}
 */
function getConfiguration({pathParams: {organizationId, configurationId}, signal}) {
  const url = `${baseApi}/organizations/${organizationId}/configurations/${configurationId}`;

  return waRequest.requestAuthenticated({url: url, method: 'get', signal});
}

/**
 * Initiate authenticated POST /address-alert-notification/v1/organizations/${organizationId}/configurations
 *
 * @param organizationId
 * @param data
 * @returns {Promise}
 */
function createConfiguration({pathParams: {organizationId}, data}) {
  const url = `${baseApi}/organizations/${organizationId}/configurations`;

  return waRequest.requestAuthenticated({url: url, method: 'post', data});
}

/**
 * Initiate authenticated PUT /address-alert-notification/v1/organizations/${organizationId}/configurations/${configurationId}
 *
 * @param organizationId
 * @param configurationId
 * @param data
 * @returns {Promise}
 */
function updateConfiguration({pathParams: {organizationId, configurationId}, data}) {
  const url = `${baseApi}/organizations/${organizationId}/configurations/${configurationId}`;

  return waRequest.requestAuthenticated({url: url, method: 'put', data});
}

/**
 * Initiate authenticated DELETE /address-alert-notification/v1/organizations/${organizationId}/configurations/${configurationId}
 *
 * @param organizationId
 * @param configurationId
 * @returns {Promise}
 */
function deleteConfiguration({pathParams: {organizationId, configurationId}}) {
  const url = `${baseApi}/organizations/${organizationId}/configurations/${configurationId}`;

  return waRequest.requestAuthenticated({url: url, method: 'delete'});
}

/**
 * Initiate authenticated PUT /address-alert-notification/v1/organizations/${organizationId}/configurations
 *
 * @param organizationId
 * @param data - { state: 'INHERIT' | 'OVERRIDE', configurations: array | null }
 * @returns {Promise}
 */
function updateConfigurations({pathParams: {organizationId}, data: {state, configurations}, signal}) {
  const url = `${baseApi}/organizations/${organizationId}/configurations`;

  return waRequest.requestAuthenticated({
    url: url,
    method: 'put',
    signal,
    data: {state, configurations},
  });
}

export default {
  getConfigurations,
  getConfiguration,
  createConfiguration,
  updateConfiguration,
  deleteConfiguration,
  updateConfigurations,
};
